import React, {Component} from 'react';

export default class KTP extends Component {
  render() {
    return (
      <div className='15.jpg upper'>
        <div className='captions h1'>Тематичкское и учебное планирование, расчет учебной нагрузки</div>
        <div className="contr contr-2">

          <a href="" className='contr-close'> </a>

          <div className='contr-label'>
            <p>Название КТП</p>
            <p>Кафедра</p>
            <p>Учебный план</p>
            <p>Дисциплина</p>
            <p>Учебная программа</p>
            <p>Схема изучения</p>
          </div>

          <div>
            <div className="inputs__input ">
              <input type="text" placeholder="Все" className="input__caption" value="КТП по психологии 2015"/>
            </div>
            <div className="inputs__input">
              <input type="text"
                     placeholder="Все"
                     className="input__caption"
                     value="Кафедра военной педагогики и психологии"/>
            </div>
            <div className="inputs__input">
              <input type="text"
                     placeholder="Все"
                     className="input__caption"
                     value="Учебный план СПО 2015"/>
            </div>
            <div className="inputs__input">
              <input type="text"
                     placeholder="Все"
                     className="input__caption"
                     value="Практическая психология"/>
            </div>
            <div className="inputs__input">
              <input type="text"
                     placeholder="Все"
                     className="input__caption"
                     value="УП Прафктическая психология 2015"/>
            </div>
          </div>

          <div className='contr-label-2'>
            <p>Учебный год</p>
            <p>Учебный период</p>
            <p>Курс</p>
            <p>Семестр</p>
            <p>Группа</p>
          </div>

          <div className='contr-input-right'>
            <div className="usp__inputs">
              <div className="inputs__own">2017-2018</div>
            </div>
            <div className="usp__inputs">
              <div className="inputs__own">1 семестр</div>
            </div>
            <div className="usp__inputs">
              <div className="inputs__own">3 курс</div>
            </div>
            <div className="usp__inputs">
              <div className="inputs__own">5 семестр</div>
            </div>
            <div className="usp__inputs" id='lol'>
              <div className="inputs__own ">15-003</div>
            </div>
          </div>

          <table className='contr-2-table'>
            <tr>
              <th className='table-title'>Код</th>
              <th className='table-title'>Номер и наименование<br/>разделов и тем</th>
              <th className='table-title'>Л</th>
              <th className='table-title'>С</th>
              <th className='table-title'>ЛР</th>
              <th className='table-title'>П</th>
              <th className='table-title'>ГУ</th>
              <th className='table-title'>ГЗ</th>
              <th className='table-title'>ТЗ</th>
              <th className='table-title'>ВИ</th>
              <th className='table-title'>КР</th>
              <th className='table-title'>КУР</th>
              <th className='table-title'>СРП</th>
              <th className='table-title'>З</th>
              <th className='table-title'>СР</th>
            </tr>
            <tr>
              <td></td>
              <td className='col1'>1-й семестр</td>
              <td>48</td>
              <td></td>
              <td>2</td>
              <td>44</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>2</td>
              <td></td>
              <td></td>
              <td>6</td>
              <td></td>
            </tr>
            <tr>
              <td>Т.1</td>
              <td>Тема 1. Введение в предмет</td>
              <td>18</td>
              <td></td>
              <td></td>
              <td>16</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>Т.2</td>
              <td>Тема 2. Основы практической психологии</td>
              <td>18</td>
              <td></td>
              <td></td>
              <td>14</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>Т.3</td>
              <td>Тема 3. Практикум по психологии</td>
              <td>12</td>
              <td></td>
              <td></td>
              <td>14</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>КР</td>
              <td>Контрольная работа</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>2</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td>Экзамен</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>6</td>
              <td></td>
            </tr>
          </table>

          <div className='contr-button'>
            <button>Добавить</button>
            <button>Изменить</button>
            <button>Удалить</button>
            <button>Сохранить</button>
          </div>

          <a href="" className='btn-save'>СОХРАНИТЬ</a>
        </div>
      </div>
    );
  }
}

